// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__31riA","spin":"Spinner_spin__2dRRO"};